import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=0a66af81&"
import script from "./plans.vue?vue&type=script&lang=js&"
export * from "./plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "plans.vue"
export default component.exports